import React from "react";
import shapImg from "../images/shap.png";
import aboutImg from "../images/comp/About.webp";

const AboutHeroPage = () => {
  return (
    <section className="about-section">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 mb-4 mb-lg-0 position-relative">
            <div className="shap-img"><img src={shapImg} className="img-fluid" alt="" /></div>
            <img src={aboutImg} alt="Team" className="img-fluid rounded about-img" />
            <div className="shap-img2"><img src={shapImg} className="img-fluid" alt="" /></div>
          </div>
          <div className="col-lg-6">
            <span className="about-label">About us</span>
            <h2 className="title">About Hope Web Solutions?</h2>
            <p className="sub-title">
              Hope Web Solutions is a leading Web and Mobile App Development company, delivering cutting-edge digital
              solutions since 2009. We specialize in crafting innovative websites and mobile applications by integrating
              the latest technologies with a client-centric approach.
            </p>
            <p className="sub-title">
              At Hope Web Solutions, we believe that great ideas deserve exceptional execution. Our team focuses on
              turning your vision into powerful digital products through smart design, robust development, and strategic
              implementation.
            </p>

            <a href="#footer" className="btn btn-orange mt-3">Contact Us</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutHeroPage;